import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./registerServiceWorker";
import VueGtm from "vue-gtm";
import VueAnalytics from "vue-analytics";
import VueMeta from "vue-meta";

import "@/assets/css/tailwind.css";
import "@/assets/css/output.css";

Vue.use(VueAnalytics, {
  id: "UA-145211612-1",
  router
});

Vue.use(VueMeta);

Vue.use(VueGtm, {
  id: "GTM-KZS8XQB", // Your GTM ID
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: true, // Whether or not display console logs debugs (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  ignoredViews: ["homepage"] // If router, you can exclude some routes name (case insensitive) (optional)
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
